import React, { useState } from 'react';

import { SurveyType } from 'models/Survey';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { SurveyServiceInstance } from 'services/surveyService';
import { AllErrors } from 'types/Errors';

import { SurveyForm } from '../CreateSurvey/CreateSurvey.props';
import { SurveyGeneratedProps } from './Survey.props';
import SurveyView from './Survey.view';

const Survey = (): JSX.Element => {
  const navigate = useNavigate();

  const surveyListQuery = useQuery('survey', SurveyServiceInstance.getList, {
    onSuccess: (data) => {
      console.log('survey data received: ', data);
    },
    onError: (err: AllErrors) => {
      console.error(err);
    },
  });

  function onClickCreate() {
    navigate('/dashboard/survey/create');
  }

  const generatedProps: SurveyGeneratedProps = {
    onClickCreate,
    loading: surveyListQuery.isLoading,
    data: surveyListQuery.data?.body || [],
  };
  return <SurveyView {...generatedProps} />;
};

export default Survey;
